const AuthService = {
    setUserSession: (userSession) => {
        localStorage.setItem('userSession', JSON.stringify(userSession));
    },
    getUserSession: () => {
        const userSession = localStorage.getItem('userSession');
        if (userSession) {
            return JSON.parse(userSession);
        } else {
            return null;
        }
    },
    removeUserSession: () => {
        localStorage.removeItem('userSession');
    },
    //updateFollowedPath: (pathId, isFollowed) => {
    //    const currentSession = AuthService.getUserSession();
    //    if (currentSession) {
    //        if (isFollowed) {
    //            // Remove pathId from followedPath
    //            currentSession.followedPath = currentSession.followedPath.filter(id => id !== pathId);
    //        } else {
    //            // Add pathId to followedPath
    //            currentSession.followedPath = [...currentSession.followedPath, pathId];
    //        }
    //        AuthService.setUserSession(currentSession);
    //    }
    //},
    syncLocalUserSession: (updatedUser) => {
        const currentSession = AuthService.getUserSession();
        if (currentSession) {
            AuthService.setUserSession({
                ...currentSession,
                ...updatedUser,
            });
        } else {
            AuthService.setUserSession(updatedUser);
        }
    }
};

export default AuthService;
